import { BlockDataForm } from '@plone/volto/components/manage/Form';
import PropTypes from 'prop-types';

import { listingPersonsSchema } from './schema';

const ListingPersonsData = (props) => {
  const { data, block, onChangeBlock, blocksErrors } = props;
  const schema = listingPersonsSchema({ ...props });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={onChangeBlock}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

ListingPersonsData.propTypes = {
  data: PropTypes.object,
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
};

export default ListingPersonsData;
